/*
 * File: /src/services/callPlanServices.js
 * Created Date: Sunday May 23rd 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 23rd May 2021 11:03:48 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */
import { authedAxios } from '../shared/axiosWrapper';
import { AD_BASE_CALLPLAN_PATH } from '../constants';

export default {

  fetchCallPlans() {
    return authedAxios.get(AD_BASE_CALLPLAN_PATH);
  },

  fetchCallPlan(id) {
    return authedAxios.get(AD_BASE_CALLPLAN_PATH + id);
  },

  updateCallPlan(id, payload) {
    return authedAxios.put(AD_BASE_CALLPLAN_PATH + id, payload);
  },

  createCallPlan(payload) {
    return authedAxios.post(AD_BASE_CALLPLAN_PATH, payload);
  },

  deleteCallPlan(id) {
    return authedAxios.delete(AD_BASE_CALLPLAN_PATH + id);
  },
};
